<template>
    <v-container>
        <div>
            <v-row justify="space-between" no-gutters>
                <v-col cols="12" sm="6" justify="center">
                    <p class="header-title"> {{$t('menu.statistic_general')}} </p>
                </v-col>

                <v-col cols="12" sm="6" justify="center">
                    <v-row justify="start">
                        <v-col cols="12" sm="4">
                            <v-autocomplete v-if="userCategory === 5 || userCategory === 4 || isAdmin" v-model="selectDepartment" :items="departments" item-text="name" v-bind:label="$t('common.chosen_department')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                            <v-autocomplete v-else-if="userCategory === 3" v-model="selectTeam" :items="teams" item-text="name" v-bind:label="$t('common.chosen_team')" outlined return-object dense background-color="#ffffff"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="5">
                            <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" persistent width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="computedDateFormatted" v-bind:label="$t('common.date_range')" readonly v-on="on" outlined dense background-color="#ffffff">
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="dates" scrollable range locale="vi" no-title>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal = false"> {{ $t('common.cancel') }} </v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(dates)"> {{ $t('common.ok') }} </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        
                        <v-col cols="12" sm="3">
                            <v-btn dark color="primary" @click="getDataStatisticByRange"> Thống kê </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <v-container class="white">
            <v-row no-gutters>
                <v-col cols="12" sm="2">
                    <v-autocomplete v-model="selectTopFilter" :items="topFilters" item-text="name" v-bind:label="$t('statistic.top_filter')" outlined return-object dense></v-autocomplete>
                </v-col>
            </v-row>
            <div> {{$t('menu.statistic_design')}} </div>
            <GChart
                :settings="{packages: ['corechart']}"    
                :data="chartDesign"
                :options="chartOptions"
                :createChart="(el, google) => new google.visualization.ColumnChart(el)"
                @ready="onChartReady"
            />
            
            <div> {{$t('menu.statistic_manufacture')}} </div>
            <GChart
                :settings="{packages: ['corechart']}"    
                :data="chartManufacture"
                :options="chartOptions"
                :createChart="(el, google) => new google.visualization.ColumnChart(el)"
                @ready="onChartReady"
            />

            <div> {{$t('menu.statistic_profit')}} </div>
            <GChart
                :settings="{packages: ['corechart']}"    
                :data="chartProfit"
                :options="chartOptions"
                :createChart="(el, google) => new google.visualization.ColumnChart(el)"
                @ready="onChartReady"
            />
        </v-container>
        <v-overlay :value="overlay" :z-index="0">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>

    
</template>
t
<script>
import { GChart } from 'vue-google-charts'
import moment from 'moment';

export default {
    components: {
        GChart
    },

    data: () => ({
        isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
        userCategory: parseInt(localStorage.getItem('category')),
        contextId: localStorage.getItem('context_id'),
        
        overlay: false,
        chartsLib: null, 
        dates: [],
        date: {},

        chartDesign: ['Ngày', 'Số lượng', { role: 'annotation'}],
        chartManufacture: ['Ngày', 'Số lượng', { role: 'annotation'}],
        chartProfit: ['Ngày', 'Doanh thu', { role: 'annotation'}],

        resultDesigns: [],
        resultManufactures: [],
        resultProfit: [],

        teams: [],
        selectTeam: {},

        selectDepartment: {},
        departments: [],

        topFilters: [
            {name: 'Tất cả', value: -1},
            {name: 'Top 5', value: 5},
            {name: 'Top 10', value: 10},
            {name: 'Top 15', value: 15}
        ],
        selectTopFilter: {},

        materialStyles: [],
        heightChart: 600,
        modal: false
    }),

    watch: {
        selectTopFilter() {
            this.filterData();
        }
    },

    computed: {
        chartOptions () {
            return {
                bars: 'horizontal', // Required for Material Bar Charts.
                hAxis: { format: 'decimal', textStyle: {fontSize: 14}},
                vAxis: {textStyle: {fontSize: 14}},
                height: this.heightChart,
                colors: ['#363F7A'],
                annotations: { textStyle: {fontSize: 14}},
                animation : {
                    startup: true,
                    duration: 200,
                    easing: 'inAndOut'
                },
                chartArea: {top: 30, width:'90%', bottom: 100},
                legend: {position: 'top', textStyle: {fontSize: 14}}
            }
        },

        computedDateFormatted () {
            if (this.dates.length < 2) {
                return;
            }

            this.sortDate();
            return this.formatDate(this.date.start) + ' ~ ' + this.formatDate(this.date.end);
        },
    },

    async created () {
        if (this.userCategory === 3) {
            this.getTeamByDepartmentId(this.contextId);
        } else if (this.userCategory >= 4 || this.isAdmin) {
            this.getDepartmentSale();
        }

        this.date.end = new Date();
        this.date.start = new Date(new Date().setDate(this.date.end.getDate() - 30));
      
        const startDate = moment(this.date.start).format("YYYY-MM-DD");
        const endDate = moment(this.date.end).format("YYYY-MM-DD");

        
        this.dates.push(startDate);
        this.dates.push(endDate);

        this.sortDate();

        Promise.all([
            this.getDataStatisticDesignByRange(),
            this.getDataStatisticManufactureByRange(),
            this.getDataStatisticProfitByRange()]
        )
        // this.getDataStatisticByRange();
        this.selectTopFilter = this.topFilters[0];
    },

    methods: {
        onChartReady (chart, google) {
            this.chartsLib = google
        },

        initialize () {
            
        },

        async getDataStatisticByRange() {
            Promise.all([
                this.getDataStatisticDesignByRange(),
                this.getDataStatisticManufactureByRange(),
                this.getDataStatisticProfitByRange()]
            )
        },

        sortDate () {
            const startDate = new Date(this.dates[0]);
            const endDate = new Date(this.dates[1]);

            if (startDate.getTime() < endDate.getTime()) {
                this.date.start = startDate;
                this.date.end = endDate;
            } else {
                this.date.start = endDate;
                this.date.end = startDate;
            }       
        },

        formatDate (date) {
            if (!date) {
                return null;
            }
            return moment(date).format("DD/MM/YYYY");
        },

        async getDataStatisticDesignByRange() {
            this.overlay = true;
            try {
                const from = moment(String(this.date.start)).format("DD/MM/YYYY");
                const to = moment(String(this.date.end)).format("DD/MM/YYYY");
                
                var response = '';
                if (this.isAdmin || this.userCategory >= 4) {
                    if (this.selectDepartment._id && this.selectDepartment._id != -1) {
                        response = await this.$http.get('/api/designRequest/contextStats/dateRange/' + this.selectDepartment._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/designRequest/dateRange?' + "from=" + from + "&to=" + to);
                    }
                } else if (this.userCategory === 3) {
                    if (this.selectTeam._id && this.selectTeam._id != -1) {
                        response = await this.$http.get('/api/designRequest/contextStats/dateRange/' + this.selectTeam._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/designRequest/contextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                    }
                } else {
                    response = await this.$http.get('/api/designRequest/contextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                }
                
               
                console.log(response);
                this.overlay = false;
                if (response.data && response.data.success) {
                    this.resultDesigns = [];

                    const arrayData = response.data.data;
                    if (arrayData) {
                        const dates = Object.keys(arrayData);
                        
                        dates.forEach(date => {
                            const number = arrayData[date];
                            const dataObject = {
                                name: date,
                                number: number
                            }

                            this.resultDesigns.push(dataObject);
                        });
                    }
                    
                    setTimeout(() =>  this.generateDataForChart(this.resultDesigns, 0), 200);
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        async getDataStatisticManufactureByRange() {
            this.overlay = true;
            try {
                const from = moment(String(this.date.start)).format("DD/MM/YYYY");
                const to = moment(String(this.date.end)).format("DD/MM/YYYY");
                
                var response = '';
                
                if (this.isAdmin || this.userCategory >= 4) {
                    if (this.selectDepartment._id && this.selectDepartment._id != -1) {
                        response = await this.$http.get('/api/manufactureRequest/FinishInContextStats/dateRange/' + this.selectDepartment._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/manufactureRequest/FinishInDateRange?' + "from=" + from + "&to=" + to);
                    }
                } else if (this.userCategory === 3) {
                    if (this.selectTeam._id && this.selectTeam._id != -1) {
                        response = await this.$http.get('/api/manufactureRequest/FinishInContextStats/dateRange/' + this.selectTeam._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/manufactureRequest/FinishInContextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                    }
                } else {
                    response = await this.$http.get('/api/manufactureRequest/FinishInContextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                }
               
                this.overlay = false;
                if (response.data && response.data.success) {
                    this.resultManufactures = [];

                    const arrayData = response.data.data;
                    if (arrayData) {
                        const dates = Object.keys(arrayData);
                        
                        dates.forEach(date => {
                            const number = arrayData[date];
                            const dataObject = {
                                name: date,
                                number: number
                            }

                            this.resultManufactures.push(dataObject);
                        });
                    }
                    
                    setTimeout(() =>  this.generateDataForChart(this.resultManufactures, 1), 200);
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        async getDataStatisticProfitByRange() {
            this.overlay = true;
            try {
                const from = moment(String(this.date.start)).format("DD/MM/YYYY");
                const to = moment(String(this.date.end)).format("DD/MM/YYYY");
                
                var response = '';
                
                if (this.isAdmin || this.userCategory >= 4) {
                    if (this.selectDepartment._id && this.selectDepartment._id != -1) {
                        response = await this.$http.get('/api/manufactureRequest/ProfitInContextStats/dateRange/' + this.selectDepartment._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/manufactureRequest/ProfitInDateRange?' + "from=" + from + "&to=" + to);
                    }
                } else if (this.userCategory === 3) {
                    if (this.selectTeam._id && this.selectTeam._id != -1) {
                        response = await this.$http.get('/api/manufactureRequest/ProfitInContextStats/dateRange/' + this.selectTeam._id + "?from=" + from + "&to=" + to);
                    } else {
                        response = await this.$http.get('/api/manufactureRequest/ProfitInContextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                    }
                } else {
                    response = await this.$http.get('/api/manufactureRequest/ProfitInContextStats/dateRange/' + this.contextId + "?from=" + from + "&to=" + to);
                }
               
                this.overlay = false;
                if (response.data && response.data.success) {
                    this.resultProfit = [];

                    const arrayData = response.data.data;
                    if (arrayData) {
                        const dates = Object.keys(arrayData);
                        
                        dates.forEach(date => {
                            const number = arrayData[date];
                            const dataObject = {
                                name: date,
                                number: number
                            }

                            this.resultProfit.push(dataObject);
                        });
                    }
                    
                    setTimeout(() =>  this.generateDataForChart(this.resultProfit, 2), 200);
                }
            } catch (e) {
                console.log(e.stack);
            }
        },


        generateDataForChart(arrayData, type) {
            if (type === 0) {
                this.chartDesign = [];
                this.chartDesign.push(['Ngày', 'Số lượng', { role: 'annotation'}]);
                
                if (Array.isArray(arrayData) && arrayData.length > 0) {
                    arrayData.forEach(item => {
                        this.chartDesign.push([item.name, item.number, item.number]);
                    });
                }
            } else if (type === 1) {
                this.chartManufacture = [];
                this.chartManufacture.push(['Ngày', 'Số lượng', { role: 'annotation'}]);
                
                if (Array.isArray(arrayData) && arrayData.length > 0) {
                    arrayData.forEach(item => {
                        this.chartManufacture.push([item.name, item.number, item.number]);
                    });
                }
            } else if (type === 2) {
                this.chartProfit = [];
                this.chartProfit.push(['Ngày', 'Doanh thu', { role: 'annotation'}]);
                
                if (Array.isArray(arrayData) && arrayData.length > 0) {
                    arrayData.forEach(item => {
                        this.chartProfit.push([item.name, item.number, item.number]);
                    });
                }
            }
            
            // this.heightChart = this.chartDatas.length * 80;
        },

        filterData() {
            if (!this.resultDesigns || !this.resultProfit || !this.resultManufactures) {
                return;
            }

            let designArray = [].concat(this.resultDesigns);
            let manufactureArray = [].concat(this.resultManufactures);
            let profitArray = [].concat(this.resultProfit);


            if (this.selectTopFilter.value > 0) {
                this.sortData(designArray);
                this.sortData(manufactureArray);
                this.sortData(profitArray);
                designArray = designArray.slice(0, this.selectTopFilter.value);
                manufactureArray = manufactureArray.slice(0, this.selectTopFilter.value);
                profitArray = profitArray.slice(0, this.selectTopFilter.value);
            }

            //  console.log(this.resutlDatas);
            this.generateDataForChart(designArray, 0);
            this.generateDataForChart(manufactureArray, 1);
            this.generateDataForChart(profitArray, 2);
        },

        sortData(array) {
            function compare(a, b) {
                if (a.number < b.number)
                    return 1;
                if (a.number > b.number)
                    return -1;
                return 0;
            }

            array.sort(compare);
        },

        async getDepartmentSale() {
            try {
                const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + '5df4859b3538a45b0a15c920');
                
                if (response.data && response.data.success) {
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.departments = [optionAll].concat(response.data.data);
                    this.selectDepartment = this.departments[0];
                }
            } catch (e) {
                console.log(e.stack);
            }
        },

        async getTeamByDepartmentId(departmentId) {
            try {
                const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + departmentId);
                
                if (response.data && response.data.success) {
                    const optionAll = {
                        name : "Tất cả",
                        _id : "-1"
                    }

                    this.teams = [optionAll].concat(response.data.data);
                    this.selectTeam = this.teams[0];
                }
            } catch (e) {
                console.log(e.stack);
                // dùng vue alert //alert(e.message);
            }
        }
    }
}
</script>